import React from 'react'
import { ProfileIcon } from '@/features/profile-page/TabBarProfile/iconsTabBar/ProfileIcon.jsx'
import { OrderIcon } from '@/features/profile-page/TabBarProfile/iconsTabBar/OrderIcon.jsx'
import { ReturnIcon } from '@/features/profile-page/TabBarProfile/iconsTabBar/ReturnIcon.jsx'
import { HistoryIcon } from '@/features/profile-page/TabBarProfile/iconsTabBar/HistoryIcon.jsx'
import { SettingsIcon } from '@/features/profile-page/TabBarProfile/iconsTabBar/SettingsIcon.jsx'

export const navigationProfile = [
    {
        text: 'Профиль',
        img: <ProfileIcon />,
    },
    {
        text: 'Мои заказы',
        img: <OrderIcon />,
    },
    {
        text: 'История транзакций',
        img: <HistoryIcon />,
    },
    {
        text: 'Настройки',
        img: <SettingsIcon />,
    },
]
